import { createWebHistory, createRouter } from "vue-router";
import FormSearchCompo from "@/components/FormSearchCompo.vue";
import JobViewCompo from "@/components/job/ViewCompo.vue";
import JobApplyCompo from "@/components/job/ApplyCompo.vue";
import RefCompo from '@/components/job/RefCompo.vue';


const routes = [
  {
    path: "/",
    // redirect:'/',
    name: "home",
    component: FormSearchCompo,
    props: true,
    meta: { title: 'CSI-GROUPS Open Position' }

  },
  {
    path: "/job/:id",
    name: "jobview",
    component: JobViewCompo,
    props: true,
    meta: { title: 'View CSI-GROUPS Open Position' }

  },
  {
    path: "/job/:id/apply",
    name: "jobapply",
    component: JobApplyCompo,
    props: true,
    meta: { title: 'Apply CSI-GROUPS Open Position' }


  },
  {
    path: "/job/apply",
    name: "jobapply_notid",
    component: JobApplyCompo,
    props: true,
    meta: { title: 'Apply CSI-GROUPS Open Position' }



  },
  {
    path: "/job/:id/ref",
    name: "jobref",
    component: RefCompo,
    props: true,
    meta: { title: 'Refer CSI-GROUPS Open Position' }


  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;